import { ItemLoader, ListLoader } from "@/loaders";

export default {
  templatesList: new ListLoader("/sms/templates/", { setter: "sms/setTemplates" }),
  templateItem: new ItemLoader("/sms/templates/", { setter: "sms/updateTemplate" }),
  log: new ListLoader("/sms/log/", {
    defaultParams: { ordering: "created_at" },
    isSingleRequest: false,
  }),
};
